import { createContext } from "react";
const CustomFormContext = createContext({});
export default CustomFormContext;
